module.exports = __webpack_public_path__ + "static/media/2.fb7aa610.png";